type TFetchParams = Parameters<typeof fetch>;
type TInput = TFetchParams[0];
type TInit = TFetchParams[1];

export function toUrlString(input: TInput): string {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  return input.url;
}

export async function safeFetch(
  called_by: string,
  input: TInput,
  init?: TInit,
): Promise<Response> {
  let response;
  try {
    response = await fetch(input, init);
  } catch (error) {
    const url = toUrlString(input);
    const message = `[${called_by}] Sem conectividade com a API ${url}. O dispositivo pode estar offline.`;
    console.warn(message, error);
    response = Response.error();
  }
  return response;
}
